module.exports = __webpack_public_path__ + "img/search.b91509d7.svg";